module.exports = __webpack_public_path__ + "assets/img/5_1351.c0a4ccc8.jpg";